module.exports = __webpack_public_path__ + "img/2.c86da25.png";